// activeSafetyForms/safetyAuditForm/state.js

import { safetyAuditFormInitialState } from "../../forms/safetyAuditForm/safetyAuditFormState";

export const activeSafetyAuditFormInitialState = {
  tabName: "safetyAuditForm",
  isLoading: false,
  error: null,
  safetyAuditMode: null,
  currentSafetyAudit: null,
  safetyAuditErrors: null,
  rev: 0, // Revision for the autosave hook to reference.
  safetyAuditForm: safetyAuditFormInitialState,
};
